import React from "react";

export default function Footer() {
  return (
    <footer className="bg-primary text-white py-10">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <p className="mt-4 text-xs text-white/80">© {new Date().getFullYear()} Estudio jurídico Farias — Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}
